module.exports = __webpack_public_path__ + "primeicons.b8eccb10.eot";